import { createUseStyles } from "react-jss";

export const CumulativeMonthColumnStyle = createUseStyles((theme: any) => ({
    header: {
        display: "flex",
        height: "-webkit-fill-available",
        alignItems: "center",
        whiteSpace: "pre-line",
        lineHeight: "initial",
        fontSize:"10px !important"
    },
    sort: {
        marginTop: "5px",
    },
    iconSort: {
        fill: theme.colors.iconSort.disabled,
        width: "16px",
    },
    iconSorted: {
        fill: theme.colors.iconSort.enabled,
        width: "16px",
    },
    sortColumn: {
        width: 14,
        display: "flex",
        position: "absolute",
    },
    dataCell: {
        textAlign: "center",
    },
}));
